// The preset character images Create offers. Its own module, not part of staticImages.jsx, because
// CreateContext (in the root layout, so in every page's first load) uses it (plan step W2,
// 2026-10-07). staticImages.jsx re-exports it.

export const sampleImagesCreate = [
  {
    id: 1,
    imageUrl: 'https://storage.promptdrive.net/demo_images/1.webp',
  },
  {
    id: 2,
    imageUrl: 'https://storage.promptdrive.net/demo_images/2.webp',
  },
  {
    id: 3,
    imageUrl: 'https://storage.promptdrive.net/demo_images/3.webp',
  },
  {
    id: 4,
    imageUrl: 'https://storage.promptdrive.net/demo_images/4.webp',
  },
  {
    id: 5,
    imageUrl: 'https://storage.promptdrive.net/demo_images/5.webp',
  },
]
